<template>

    <div id="rullgardin" class="rullgard"  @mouseleave="stangGardin()" >
        <div id="steg1" class="linkstyle2" @click="valjSteg(1)"> Steg 1 </div>
        <div id="steg2" class="linkstyle2" @click="valjSteg(2)"> Steg 2 </div>
        <div id="steg3" class="linkstyle2" @click="valjSteg(3)"> Steg 3 </div>
        <div id="steg4" class="linkstyle2" @click="valjSteg(4)"> Steg 4 </div>
        <div id="steg5" class="linkstyle2" @click="valjSteg(5)"> Steg 5 </div>
        <div id="steg0" class="linkstyle2" @click="valjSteg(0)"> Alla steg </div>

    </div>


</template>

<script>

export default {
  name: 'Rullgardinen',
  props: {
    //synsRullgardin: Boolean,
    steget: String



},
methods:  {


    valjSteg: function(index) {

        window.document.done["Steg"] = index;

        this.$root.$emit('myEvent', 'new message!')
        this.stangGardin();

    },
    stangGardin: function() {

        this.$emit('update', false);

    },

},

mounted: function() {

        var index =  window.document.done["Steg"];
        for (var i=0; i<=5; i++) {
            document.getElementById('steg'+i).classList.remove("valtSteg");
        }
        document.getElementById('steg'+index).classList.add("valtSteg");
        //window.onclick = function() {that.andraHeader()};
},



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.rullgard {
    position: absolute;
    left: calc(50vw + 100px);
    background-color: #aaa;
    padding: 1em;
    width: 135px;
    z-index: 10;
}

.rullgard2 {
    position: absolute;
    left: calc(50vw + 300px);
    background-color: #aaa;
    padding: 1em;
    width: 135px;
    z-index: 10;
}


.linkstyle {
    font-size: 1.2em;
    color: #2c3e50;
    text-decoration: none;
}

.linkstyle:hover {
    color:brown;
    transition: .5s;
}


.linkstyle2 {
    font-size: 1.2em;
    color: #2c3e50;
    text-decoration: none;
}



.rulloption {
    text-decoration: none;
    display: block;
}



.osynlig {
    display: none;
}

.valtSteg {
    color: brown;
}

.pseudo-link {
    color: #2c3e50;
    text-decoration: none;
    display: inline;
}

.pseudo-link:hover {
    color:brown;
    transition: .5s;
    cursor: pointer;
}

.linkstyle2:hover {
    background-color: white;
}




@media (max-width: 550px) {
    .rullgard {
        left: calc(50vw - 80px);
    }

}

@media (max-width: 480px) {
    .rullgard2 {
        left: calc(100vw - 200px);
    }

}




</style>
